import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'keys' })
export class KeysPipe implements PipeTransform {
  constructor() {}

  transform(values): any {
    const keys = [];
    for (const entry in values) {
      if (values[entry] != null) {
        keys.push({ key: entry, value: values[entry] });
      }
    }
    return keys;
  }
}
